export enum TilesRoutes {
  //root = 'tiles', // TODO see this...
  root = 'sidedrawer-type',
  main = '',
  recordtypes = 'recordtypes',
  'record-types' = 'record-types',
}
